export function byDesc(a, b) {
    const [desc1, desc2] = (a.descrizione == null) ? [a.desc, b.desc]: [a.descrizione, b.descrizione];
    return desc1?.trim().localeCompare(desc2.trim());
}
